// src/lib/outcomeIcons.js
//
// Maps sOutcome.id → icon filename (without extension).
// Icons live at /public/icons/outcomes/<name>.png
// Ported from takso-poc/takso-reporting-ui/src/lib/outcomeIcons.js

export const OUTCOME_ICONS = {
  1: 'creativity-stimulated',
  2: 'aesthetic-enrichment',
  3: 'knowledge-ideas-insight',
  4: 'diversity-cultural-expression',
  5: 'cultural-heritage-belonging',
  6: 'wellbeing',
  7: 'safety-security',
  8: 'feeling-valued',
  9: 'social-connectedness',
  10: 'employment-skills',
  11: 'individual-economic-wellbeing',
  13: 'local-economy',
  16: 'civic-pride',
  17: 'networks-resources',
  19: 'agency-voice',
  20: 'sense-of-place',
  21: 'natural-world',
  22: 'ecological-issues',
  23: 'environmental-stewardship',
  26: 'social-differences-bridged',
  30: 'professional-practice',
  31: 'civic-trust',
};
